import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing, { SegmentPage } from "@/pages/Landing";
import { PlanosPage, FuncionalidadesPage, ContatoPage, RaioXPage, BlogPage, BlogPostPage } from "@/pages/Marketing";
import ReferralPage from "@/components/Growth";
import { AdminMetrics, AdminLeads, AdminSettings, AdminContent } from "@/pages/AdminGrowth";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import { AppShell } from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import POS from "@/pages/POS";
import OrdersBoard from "@/pages/OrdersBoard";
import Kitchen from "@/pages/Kitchen";
import PrintBridge from "@/pages/PrintBridge";
import Inventory from "@/pages/Inventory";
import Finance from "@/pages/Finance";
import CRM from "@/pages/CRM";
import Reports from "@/pages/Reports";
import Subscription from "@/pages/Subscription";
import Settings from "@/pages/Settings";
import Stores from "@/pages/Stores";
import PublicMenu from "@/pages/PublicMenu";
import TvBoard from "@/pages/TvBoard";
import Waiter from "@/pages/Waiter";
import OrderTracking from "@/pages/OrderTracking";
import { AdminShell } from "@/components/AdminShell";
import { AdminLogin, AdminDashboard, AdminTenants, AdminPlans, AdminCoupons, AdminSupport, AdminAudit, AdminGateway } from "@/pages/AdminPages";
import AdminAccount from "@/pages/AdminAccount";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-stone-500">Carregando...</div>;
  if (!user) return <Navigate to="/entrar" replace />;
  return children;
}
function AdminProtected({ children }) {
  const t = localStorage.getItem("pg_admin_token");
  if (!t) return <Navigate to="/admin-master/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/planos" element={<PlanosPage />} />
          <Route path="/funcionalidades" element={<FuncionalidadesPage />} />
          <Route path="/raio-x" element={<RaioXPage />} />
          <Route path="/contato" element={<ContatoPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          {["hamburgueria", "pizzaria", "restaurante", "lanchonete", "marmitaria", "delivery", "confeitaria", "cafeteria"].map((s) => <Route key={s} path={`/${s}`} element={<SegmentPage />} />)}
          <Route path="/:segment" element={<Navigate to="/" replace />} />
          <Route path="/cadastro" element={<Navigate to={`/comecar${window.location.search}`} replace />} />
          <Route path="/entrar" element={<Auth mode="login" />} />
          <Route path="/comecar" element={<Auth mode="signup" />} />
          <Route path="/menu/:slug" element={<PublicMenu />} />
          <Route path="/pedido/:slug/:oid" element={<OrderTracking />} />
          <Route path="/tv/:slug" element={<TvBoard />} />

          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="pdv" element={<POS />} />
            <Route path="garcom" element={<Waiter />} />
            <Route path="pedidos" element={<OrdersBoard />} />
            <Route path="cozinha" element={<Kitchen />} />
            <Route path="imprimir" element={<PrintBridge />} />
            <Route path="produtos" element={<Products />} />
            <Route path="estoque" element={<Inventory />} />
            <Route path="financeiro" element={<Finance />} />
            <Route path="clientes" element={<CRM />} />
            <Route path="unidades" element={<Stores />} />
            <Route path="relatorios" element={<Reports />} />
            <Route path="configuracoes" element={<Settings />} />
            <Route path="assinatura" element={<Subscription />} />
            <Route path="indicacoes" element={<ReferralPage />} />
          </Route>

          <Route path="/admin-master/login" element={<AdminLogin />} />
          <Route path="/admin-master" element={<AdminProtected><AdminShell /></AdminProtected>}>
            <Route index element={<AdminDashboard />} />
            <Route path="empresas" element={<AdminTenants />} />
            <Route path="planos" element={<AdminPlans />} />
            <Route path="pagamentos" element={<AdminGateway />} />
            <Route path="cupons" element={<AdminCoupons />} />
            <Route path="suporte" element={<AdminSupport />} />
            <Route path="logs" element={<AdminAudit />} />
            <Route path="conta" element={<AdminAccount />} />
            <Route path="metricas" element={<AdminMetrics />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="configuracoes" element={<AdminSettings />} />
            <Route path="conteudo" element={<AdminContent />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
